import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Filter, MapPin, Clock, Car, Bike, Leaf, CheckCircle2, XCircle } from 'lucide-react';
import { BottomNav } from './BottomNav';
interface ActivityScreenProps {
  onTabChange: (tab: 'home' | 'activity' | 'account') => void;
}
export function ActivityScreen({
  onTabChange
}: ActivityScreenProps) {
  const [filter, setFilter] = useState<'all' | 'completed' | 'cancelled'>('all');
  const rides = [{
    id: 1,
    date: 'Today',
    from: 'Central Market',
    to: 'Home',
    vehicle: 'Comfort',
    price: '4.20',
    status: 'completed',
    time: '2:30 PM',
    icon: Car
  }, {
    id: 2,
    date: 'Yesterday',
    from: 'Tech Hub',
    to: 'Coffee Shop',
    vehicle: 'Eco',
    price: '2.50',
    status: 'completed',
    time: '9:15 AM',
    icon: Leaf
  }, {
    id: 3,
    date: 'Yesterday',
    from: 'Home',
    to: 'Gym',
    vehicle: 'Boda',
    price: '1.50',
    status: 'cancelled',
    time: '8:00 AM',
    icon: Bike
  }, {
    id: 4,
    date: 'This Week',
    from: 'Airport',
    to: 'Downtown',
    vehicle: 'Comfort',
    price: '8.00',
    status: 'completed',
    time: 'Mon, 4:00 PM',
    icon: Car
  }];
  const filteredRides = filter === 'all' ? rides : rides.filter(ride => ride.status === filter);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="flex h-full flex-col bg-slate-50" data-id="element-32">
      <div className="flex-1 px-6 pb-24" data-id="element-33">
        {/* Header */}
        <header className="mb-6 mt-4 flex items-center justify-between" data-id="element-34">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-35">Activity</h1>
          <button className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-slate-100" data-id="element-36">
            <Filter className="h-5 w-5 text-slate-600" data-id="element-37" />
          </button>
        </header>

        {/* Filters */}
        <div className="mb-6 flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-38">
          {['all', 'completed', 'cancelled'].map(f => <button key={f} onClick={() => setFilter(f as any)} className={`rounded-full px-4 py-2 text-sm font-medium capitalize transition-colors ${filter === f ? 'bg-slate-900 text-white' : 'bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-50'}`} data-id="element-39">
              {f}
            </button>)}
        </div>

        {/* Ride List */}
        <div className="flex flex-col gap-4" data-id="element-40">
          {filteredRides.map((ride, index) => <motion.div key={ride.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.05
        }} className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100" data-id="element-41">
              <div className="mb-3 flex items-center justify-between border-b border-slate-50 pb-3" data-id="element-42">
                <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider" data-id="element-43">
                  {ride.date} • {ride.time}
                </span>
                <div className={`flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${ride.status === 'completed' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`} data-id="element-44">
                  {ride.status === 'completed' ? <CheckCircle2 className="h-3 w-3" data-id="element-45" /> : <XCircle className="h-3 w-3" data-id="element-46" />}
                  {ride.status}
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-47">
                <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${ride.vehicle === 'Eco' ? 'bg-green-50 text-green-600' : ride.vehicle === 'Boda' ? 'bg-orange-50 text-orange-600' : 'bg-blue-50 text-blue-600'}`} data-id="element-48">
                  <ride.icon className="h-5 w-5" data-id="element-49" />
                </div>

                <div className="flex-1" data-id="element-50">
                  <div className="mb-2" data-id="element-51">
                    <div className="flex items-center gap-2" data-id="element-52">
                      <div className="h-1.5 w-1.5 rounded-full bg-slate-300" data-id="element-53"></div>
                      <p className="text-sm font-medium text-slate-900" data-id="element-54">
                        {ride.from}
                      </p>
                    </div>
                    <div className="ml-[2.5px] h-3 w-0.5 bg-slate-100 my-0.5" data-id="element-55"></div>
                    <div className="flex items-center gap-2" data-id="element-56">
                      <div className="h-1.5 w-1.5 rounded-full bg-slate-900" data-id="element-57"></div>
                      <p className="text-sm font-medium text-slate-900" data-id="element-58">
                        {ride.to}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between" data-id="element-59">
                    <span className="text-xs text-slate-500" data-id="element-60">
                      {ride.vehicle}
                    </span>
                    <span className="font-bold text-slate-900" data-id="element-61">
                      {ride.price} cUSD
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      <BottomNav activeTab="activity" onTabChange={onTabChange} data-id="element-62" />
    </motion.div>;
}